import script from "./BoardView.vue?vue&type=script&setup=true&lang=ts"
export * from "./BoardView.vue?vue&type=script&setup=true&lang=ts"

import "./BoardView.vue?vue&type=style&index=0&id=c5dff28c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c5dff28c"]])

export default __exports__